module.exports = __webpack_public_path__ + "img/jd.83a57895.png";